import { useToast } from '@/hooks/use-toast';
import { cn } from '@/lib/utils';
import { agentsHooks } from '@/manager';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ExpirationVerifyProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  disabledClassName?: string;
}

/** 到期验证组件 */
export const ExpirationVerify = React.forwardRef<HTMLDivElement, ExpirationVerifyProps>(({
  children,
  className,
  disabledClassName,
  onClickCapture,
  ...restProps
}, ref) => {
  const { isAgentExpired } = agentsHooks.useGetCurrentAgent();
  const { t } = useTranslation();
  const toast = useToast();

  const handleClickCapture = (event: React.MouseEvent<HTMLDivElement>) => {
    onClickCapture?.(event);
    if (event.defaultPrevented) {
      return;
    }

    if (!isAgentExpired) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    toast.toast({ description: t('agent_dashboard.expired_action_tips') });
  };

  return (
    <div
      ref={ref}
      className={cn(
        'relative inline-flex',
        isAgentExpired && 'cursor-not-allowed opacity-50',
        isAgentExpired && disabledClassName,
        className,
      )}
      onClickCapture={handleClickCapture}
      {...restProps}
    >
      {children}
      {isAgentExpired && <div className='absolute inset-0 z-10 rounded-[inherit]' />}
    </div>
  );
});

ExpirationVerify.displayName = 'ExpirationVerify';
